// auto-generated by Typewriter template _models.tst from PortCall.Models\DomainSettings\AgentRestrictionSettings.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// AgentRestrictionSettingsData is the class that AgentRestrictionSettings serializes to/from
export interface AgentRestrictionSettingsData {
	
	
    PreventAgentDoubleBookings : boolean;
}

// AgentRestrictionSettingsOptions is the class which may be passed to the AgentRestrictionSettings constructor to define optional initial data values
export interface AgentRestrictionSettingsOptions {
	
	
    PreventAgentDoubleBookings? : boolean;
}

export class AgentRestrictionSettings {
	
	
    public PreventAgentDoubleBookings : DataSignal<boolean>;

    constructor();
    constructor(data : AgentRestrictionSettingsOptions);
    constructor(data: AgentRestrictionSettingsOptions | null = null) {
	    
	    
        this.PreventAgentDoubleBookings = jsonableObservable(S.value<boolean>(data && data.PreventAgentDoubleBookings !== undefined ? data.PreventAgentDoubleBookings : false));
    }

    static key(obj : AgentRestrictionSettings) {
        return ;
    }
    
    static dataKey(obj : AgentRestrictionSettingsOptions) {
        return ;
    }

    static update(obj : AgentRestrictionSettings, data : AgentRestrictionSettingsOptions) {
        S.freeze(() => {
	        
	        
            if (data.PreventAgentDoubleBookings !== undefined) obj.PreventAgentDoubleBookings(data.PreventAgentDoubleBookings);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/AgentRestrictionSettings.ts